module.exports = "//public.zight.com/packs/media/images/annotate/tools-history-forward-39fab11eab5518e585a2e2d58bb30b87.svg";